import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    signinViewContainer: {
      height: '700px',
      background: '#D8D8D8',
      color: '#2A2A2A',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      margin: '0px 72px 80px',
      overflow: 'hidden',
      borderRadius: '8px',
      width: 'auto',
      [theme.breakpoints.only('md')]: {
        height: '750px !important'
      },
      [theme.breakpoints.down('md')]: {
        height: '100%',
        margin: '0px 0px 40px 0px'
      }
    },
    signinViewImageBlocks: {
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      }
    },
    signinViewBlocks: {
      background: 'white',
      color: '#2A2A2A',
      padding: '48px 72px 55px 40px',
      width: '50%',
      [theme.breakpoints.up('md')]: {
        flexBasis: '100% !important'
      },
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%'
      },
      [theme.breakpoints.down('xs')]: {
        padding: '24px 32px 25px 32px'
      }
    },
    signinHeaderBox: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 53px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 8px 0px',
        paddingLeft: '23px'
      }
    },
    signinHeading: {
      lineHeight: '1.2',
      fontWeight: 600,
      fontSize: '64px',
      margin: '0px',
      letterSpacing: 'normal',
      fontFamily: 'Poppins, sans-serif',
      [theme.breakpoints.down('sm')]: {
        fontSize: '45px'
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: '24px'
      }
    },
    signinEmail: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 32px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 8px 0px'
      },
      // changing the style of textfield
      '& > * > label': {
        [theme.breakpoints.down('xs')]: {
          height: '25px',
          marginBottom: '0px',
          marginTop: '10px'
        }
      },
      '& > * > * > input': {
        background: 'white',
        borderRadius: '50px',
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      },
      '& > * > * > input:-webkit-autofill-selected': {
        background: 'white',
        borderRadius: '50px'
      }
    },
    signinPassword: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 24px 0px',
      [theme.breakpoints.down('xs')]: {
        margin: '0px 0px 12px 0px'
      },
      // changing the style of textfield
      '& > * > label': {
        [theme.breakpoints.down('xs')]: {
          height: '25px',
          marginBottom: '0px',
          marginTop: '10px'
        }
      },
      '& > * > * > input': {
        background: 'white',
        borderRadius: '50px',
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      },
      '& > * > * > input:-webkit-autofill-selected': {
        background: 'white',
        borderRadius: '50px'
      }
    },
    signinButton: {
      width: '334px',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        height: '49px'
      }
    },
    signinForgotPassword: {
      flex: 'none',
      background: 'transparent',
      margin: '0px 0px 12px 0px',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '18px'
      }
    }
  })
);
